<div class="filter-item {{'filter-name-' + name}}">
  @if (!multiSelect) {
    <!-- autocomplete single select -->
    @if (isAutocomplete) {
      <app-autocomplete [width]="width" heightSizing="dynamic" [label]="placeholder |translate"
        [placeholder]="emptyPlaceholder" [itemsList]="items" [groupedItems]="groupedItems"
        [emptyValueAllowed]="showClearButton" [emptyValue]="autocompleteEmptyValue" [disabled]="disabled"
        [(ngModel)]="autocompleteValue" (ngModelChange)="valueChanged($event)" [matTooltip]="tooltip">
      </app-autocomplete>
    }
    <!-- drop-down single select -->
    @if (!isAutocomplete) {
      <mat-form-field class="full-width" subscriptSizing="dynamic">
        <mat-label>{{placeholder ? (placeholder | translate) : ''}}</mat-label>
        <mat-select [(ngModel)]="value" (selectionChange)="valueChanged(value)" [disabled]="disabled" [matTooltip]="tooltip">
          @for (item of items; track item.id) {
            <mat-option
              [value]="item.id"
              class="mat-option-text {{'filter-' + name}} {{'option-' + item.id}}"
              >
              {{item.name | translate}}
            </mat-option>
          }
        </mat-select>
        @if (showClearButton && value) {
          <button matSuffix mat-icon-button class="reset-btn" aria-label="Clear"
            (click)="clearValue(); $event.stopPropagation()">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    }
  }
  <!-- autocomplete multi select -->
  @if (multiSelect) {
    <mat-form-field class="filter-multiselect" [style.width]="width" subscriptSizing="dynamic">
      <app-multiselect-autocomplete [itemsList]="items" [placeholder]="placeholder | translate"
        [(ngModel)]="autocompleteValue" class="multiselect-autocomplete" (ngModelChange)="valueChangedMulti($event)">
      </app-multiselect-autocomplete>
    </mat-form-field>
  }
</div>